import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Category } from '../models/category';
import { CrudService } from './crud.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CategoryService extends CrudService<Category> {
  protected basePath = 'category'; // Specific for CategoryService
  public instanceType = 'category'; // Used in base service for constructing URLs

  updateLockStatus(ids: string[], isLocked: boolean): Observable<Category> {
    if (isLocked) {
      return this.http.put<Category>(`${this.getBaseUrl()}/lockMany`, ids);
    } else {
      return this.http.put<Category>(`${this.getBaseUrl()}/unlockMany`, ids);
    }
  }

  constructor(http: HttpClient) {
    super(http);
  }
}
